/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { PresenterError, PresenterOneLoggedinLogResponse } from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class LoggedinLogs<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * @description List loggedin_logs
   *
   * @tags loggedin_logs
   * @name LoggedinLogsList
   * @summary List the loggedin_logs
   * @request GET:/loggedin_logs
   */
  loggedinLogsList = (
    query?: {
      'filter[created_at]'?: string[]
      /** @min 1 */
      'filter[user]'?: number
      sort?: string[]
      'page[number]'?: number
      'page[size]'?: number
    },
    params: RequestParams = {}
  ) =>
    this.http.request<PresenterOneLoggedinLogResponse[], PresenterError>({
      path: `/loggedin_logs`,
      method: 'GET',
      query: query,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
}
